import { Building2, TrendingDown, Star, BadgeCheck } from "lucide-react";

const fmtEur = (n) =>
  new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(Number(n || 0));

export default function ProvidersSection({ providers = [] }) {
  if (!providers || providers.length === 0) return null;
  // Sort by match_score desc just in case
  const sorted = [...providers].sort((a, b) => (b.match_score || 0) - (a.match_score || 0));

  return (
    <section className="mt-12" data-testid="providers-section">
      <div className="mb-6">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-blue-700">
          Onafhankelijk leveranciersadvies
        </span>
        <h2 className="mt-2 font-heading text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">
          Top 3 alternatieve energieleveranciers voor jou
        </h2>
        <p className="mt-2 text-slate-600 max-w-2xl">
          Op basis van je contracttype, verbruik en zonnepaneel-situatie. Op maat samengesteld — geen affiliate gepush, geen tussenpersoon.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-5">
        {sorted.slice(0, 3).map((p, i) => (
          <div
            key={i}
            className={`relative bg-white border rounded-2xl p-6 flex flex-col transition-all hover:shadow-[0_8px_30px_-12px_rgba(15,23,42,0.15)] ${
              i === 0 ? "border-blue-200 ring-1 ring-blue-100" : "border-slate-200"
            }`}
            data-testid={`provider-card-${i}`}
          >
            {i === 0 && (
              <div className="absolute -top-3 left-5 bg-blue-700 text-white text-[11px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full">
                Beste match
              </div>
            )}
            <div className="flex items-start justify-between">
              <div className="h-11 w-11 rounded-xl bg-blue-50 border border-blue-100 grid place-items-center">
                <Building2 className="h-5 w-5 text-blue-700" />
              </div>
              {typeof p.match_score === "number" && (
                <div className="flex items-center gap-1 bg-amber-50 border border-amber-100 px-2 py-1 rounded-full">
                  <Star className="h-3 w-3 text-amber-500 fill-amber-500" />
                  <span className="text-xs font-semibold text-amber-700">{Math.round(p.match_score)}/100</span>
                </div>
              )}
            </div>

            <h3 className="mt-4 font-heading text-xl font-bold text-slate-900">{p.name}</h3>
            <div className="mt-1 inline-flex items-center gap-1.5 text-xs text-slate-600">
              <BadgeCheck className="h-3.5 w-3.5 text-emerald-600" />
              {p.contract_type} · {p.contract_term}
            </div>

            <p className="mt-3 text-sm text-slate-600 leading-relaxed flex-1">{p.reason}</p>

            <div className="mt-4 pt-4 border-t border-slate-100 grid grid-cols-2 gap-3">
              <div>
                <div className="text-[11px] uppercase tracking-wider text-slate-500 font-medium">Geschatte kosten</div>
                <div className="font-heading text-base font-bold text-slate-900 mt-0.5">
                  {fmtEur(p.expected_yearly_cost)}<span className="text-xs text-slate-400 font-normal">/jaar</span>
                </div>
              </div>
              <div>
                <div className="text-[11px] uppercase tracking-wider text-emerald-700 font-medium">Besparing</div>
                <div className="font-heading text-base font-bold text-emerald-700 mt-0.5 flex items-center gap-1">
                  <TrendingDown className="h-3.5 w-3.5" />
                  {fmtEur(p.expected_savings)}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <p className="mt-4 text-xs text-slate-500" data-testid="providers-disclaimer">
        Aanbevelingen zijn samengesteld op basis van publieke marktinformatie. Tarieven zijn indicatief —
        vraag altijd een actuele offerte aan voordat je overstapt.
      </p>
    </section>
  );
}
